/* Tab row — ported from the prototype's tabrow(). Underlined tab links for
   the Diligence and Stress Test sub-workspaces. */
import React from 'react';
import { Link } from 'react-router-dom';

export default function TabRow({ baseHref, tabs, activeTab }) {
	return (
		<nav className="tabrow">
			{tabs.map(t => (
				<Link key={t.id} to={`${baseHref}/${t.id}`} className={t.id === activeTab ? 'is-active' : ''}>{t.name}</Link>
			))}
		</nav>
	);
}
